var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/InfoBannerWithCTA/index.tsx
import React3 from "react";
import { Click as Click2, useTheme } from "vcc-ui";

// src/components/InfoBanner/index.tsx
import React from "react";
import { useTranslate } from "@volvo-cars/react-shared-translations";
import { Click, Icon, Text, ThemePicker } from "vcc-ui";
var InfoBanner = React.forwardRef(function InfoBannerInner(props, ref) {
  const {
    children,
    offsetY = 0,
    onDismiss,
    sticky = false,
    zIndex = 10
  } = props;
  const closeLabel = useTranslate("react-info-banner.close");
  return /* @__PURE__ */ React.createElement(ThemePicker, {
    variant: "dark"
  }, /* @__PURE__ */ React.createElement(Text, {
    as: "div",
    ref,
    variant: "kelly",
    subStyle: "emphasis",
    extend: ({ theme: { baselineGrid, color } }) => ({
      backgroundColor: color.background.primary,
      boxSizing: "border-box",
      display: "flex",
      padding: `${baselineGrid * 1.5}px ${baselineGrid * 3}px`,
      position: sticky ? "sticky" : "relative",
      top: offsetY,
      whiteSpace: "pre",
      zIndex,
      justifyContent: "flex-start",
      fromM: {
        justifyContent: "center"
      }
    })
  }, children, onDismiss && /* @__PURE__ */ React.createElement(Click, {
    extend: ({ theme: { baselineGrid } }) => ({
      display: "inline-flex",
      position: "absolute",
      right: `${baselineGrid * 3}px`
    }),
    onClick: (e) => onDismiss(e),
    "aria-label": closeLabel
  }, /* @__PURE__ */ React.createElement(Icon, {
    type: "navigation-close-24"
  }))));
});

// src/components/InfoCTA/index.tsx
import React2 from "react";
import { Block, Icon as Icon2 } from "vcc-ui";
var InfoCTA = React2.forwardRef(function InfoCTAInner(props, ref) {
  const { children, mobileCollapse = false } = props;
  return /* @__PURE__ */ React2.createElement(Block, {
    ref,
    extend: { display: "inline-flex" }
  }, /* @__PURE__ */ React2.createElement(Block, {
    extend: ({ theme: { baselineGrid, typeScale } }) => __spreadProps(__spreadValues({
      display: "inline-flex",
      marginLeft: baselineGrid * 3
    }, typeScale.kelly.emphasis.styles), {
      onlyS: {
        display: mobileCollapse ? "none" : "inline-flex"
      }
    })
  }, children), /* @__PURE__ */ React2.createElement(Block, {
    extend: ({ theme: { baselineGrid } }) => ({
      display: "inline-flex",
      marginLeft: baselineGrid,
      alignItems: "center"
    })
  }, /* @__PURE__ */ React2.createElement(Icon2, {
    type: "navigation-chevronforward-12"
  })));
});

// src/InfoBannerWithCTA/index.tsx
var InfoBannerWithCTA = (props) => {
  const _a = props, { children, linkText, href, onClick } = _a, rest = __objRest(_a, ["children", "linkText", "href", "onClick"]);
  const { typeScale, direction } = useTheme();
  const { kelly } = typeScale;
  return /* @__PURE__ */ React3.createElement(InfoBanner, __spreadValues({}, rest), href || onClick ? /* @__PURE__ */ React3.createElement(Click2, {
    dir: direction,
    href,
    onClick: onClick && ((e) => onClick(e)),
    extend: ({ theme: { color } }) => __spreadValues({
      color: color.foreground.primary,
      textDecoration: "none"
    }, kelly.emphasis.styles)
  }, children, /* @__PURE__ */ React3.createElement(InfoCTA, {
    mobileCollapse: true
  }, linkText)) : /* @__PURE__ */ React3.createElement(React3.Fragment, null, children, /* @__PURE__ */ React3.createElement(InfoCTA, {
    mobileCollapse: true
  }, linkText)));
};

// src/hooks/useDismiss/index.ts
import { useCallback, useEffect, useRef, useState } from "react";
var COOKIE_NAME = "info-banner-dismissed";
var defaultKey = "_bannerdefault_";
function useDismiss({
  key = defaultKey,
  persistToCookie = false
} = {}) {
  const [visible, setVisible] = useState(!persistToCookie);
  const didCheckCookie = useRef("");
  useEffect(() => {
    if (didCheckCookie.current !== key && getValue(persistToCookie)) {
      setVisible(!isDismissed(key));
      didCheckCookie.current = key;
    }
  }, [key, persistToCookie]);
  const dismiss = useCallback(() => {
    setVisible(false);
    if (getValue(persistToCookie)) {
      saveDismissal(key);
      didCheckCookie.current = key;
    }
  }, [key, persistToCookie]);
  return { dismiss, visible };
}
function saveDismissal(key) {
  const dismissals = getParamsCookie();
  dismissals.set(key, "true");
  let cookie = `${COOKIE_NAME}=${dismissals};domain=${window.location.hostname}`;
  if (key !== defaultKey) {
    cookie += `${cookie};path=/`;
  }
  document.cookie = cookie;
}
function isDismissed(key) {
  const dismissals = getParamsCookie();
  return dismissals.get(key) === "true";
}
function getParamsCookie() {
  var _a;
  return new URLSearchParams((_a = document.cookie.match(`(^|;)\\s*${COOKIE_NAME}\\s*=\\s*([^;]+)`)) == null ? void 0 : _a.pop());
}
function getValue(x) {
  if (typeof x === "boolean") {
    return x;
  }
  if (typeof x === "function") {
    return x();
  }
}

// src/components/InfoLink/index.tsx
import React4 from "react";
import { Click as Click3 } from "vcc-ui";
var InfoLink = React4.forwardRef(function InfoLink2(props, ref) {
  const { children, href } = props;
  return /* @__PURE__ */ React4.createElement(Click3, __spreadProps(__spreadValues({}, props), {
    href,
    ref,
    extend: ({ theme: { color, typeScale } }) => __spreadValues({
      color: color.foreground.primary,
      display: "inline-block",
      textDecoration: "underline"
    }, typeScale.kelly.emphasis.styles)
  }), children);
});
export {
  InfoBanner,
  InfoBannerWithCTA,
  InfoLink,
  useDismiss
};
